import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-420a4531"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  "class": "app-mian"
};
var _hoisted_2 = {
  "class": "app-mian-top"
};
var _hoisted_3 = {
  "class": "main-content lg:max-w-1200"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_ext_header = _resolveComponent("ext-header");

  var _component_router_view = _resolveComponent("router-view");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_ext_header), _createElementVNode("div", _hoisted_3, [_createVNode(_component_router_view, null, {
    "default": _withCtx(function (_ref) {
      var Component = _ref.Component;
      return [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))];
    }),
    _: 1
  })])])]);
}